import type { Patient, Practitioner, Reference } from '@medplum/fhirtypes'
import { StandardTask } from '@seen/core/models/tasks/standard/standardTask'
import { useSearch } from '#src/hooks/useSearch.ts'

interface UseMyTasksCountResult {
  count: number
  isLoading: boolean
}

export function useMyTasksCount(
  participant: Reference<Patient> | undefined,
  currentPractitioner: Reference<Practitioner> | undefined
): UseMyTasksCountResult {
  const { data: myTasks = [], isLoading } = useSearch(
    StandardTask,
    participant && currentPractitioner
      ? {
          ...StandardTask.activeByParticipant(participant),
          owner: currentPractitioner,
        }
      : undefined,
    { query: { enabled: !!participant && !!currentPractitioner } }
  )

  return { count: myTasks.length, isLoading }
}
